import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Dice5, Sparkles, PenTool, Printer, Cable, Heart, Gem, Palette, Coffee } from 'lucide-react';
import { Button } from '../components/Button';
import { Card, CardContent, CardHeader, CardFooter } from '../components/Card';
import { WorkshopCard } from '../components/WorkshopCard';
import { QuoteSlider } from '../components/QuoteSlider';
import { stories } from '../data/stories';
export function Home() {
  const featuredWorkshops = [{
    id: '3',
    title: '2D naaldvilten in borduurring',
    date: 'di 10 feb 2026',
    time: '19:00 t/m 21:30',
    theme: 'Draad'
  }, {
    id: '5',
    title: 'Strandhuisje voor muis – ouder-kind workshop',
    date: 'di 17 feb 2026',
    time: '10:00 t/m 12:00',
    theme: 'Keramiek'
  }, {
    id: '7',
    title: 'Fermenteren: maak je eigen Kombucha met Selia&Scob',
    date: 'di 17 feb 2026',
    time: '19:00 t/m 21:30',
    theme: 'Koken',
    volzet: true
  }];
  return <div data-id="element-627">
      {/* Hero section */}
      <section className="relative bg-gray-100 border-b border-gray-300" data-id="element-628">
        <div className="relative h-[480px] md:h-[560px] overflow-hidden" data-id="element-629">
          <div className="absolute inset-0 border-2 border-dashed border-gray-300 flex items-center justify-center bg-gray-100" data-id="element-630">
            <span className="text-gray-400 text-lg" data-id="element-631">Hero afbeelding</span>
          </div>
          <div className="absolute inset-0 flex flex-col items-center justify-center z-10 px-4 pointer-events-none" data-id="element-632">
            <div className="bg-white/90 border border-gray-200 rounded-lg px-8 py-8 md:px-12 md:py-10 text-center pointer-events-auto" data-id="element-633">
              <h1 className="text-4xl md:text-5xl font-bold mb-2" data-id="element-634">
                De Maekerij
              </h1>
              <p className="text-gray-500 text-sm tracking-widest uppercase" data-id="element-635">
                Praat · Smaak · Maak
              </p>
            </div>
          </div>

          {/* Bottom navigation links */}
          <div className="absolute bottom-0 left-0 right-0 z-10" data-id="element-636">
            <div className="grid grid-cols-2 md:grid-cols-4" data-id="element-637">
              <Link to="/maekerscafés" className="bg-gray-100 text-gray-800 text-center py-4 px-4 font-medium uppercase tracking-wide hover:bg-gray-200 transition-colors duration-150 border-r border-gray-300" data-id="element-638">
                Maekerscafés
              </Link>
              <Link to="/workshop-info" className="bg-gray-100 text-gray-800 text-center py-4 px-4 font-medium uppercase tracking-wide hover:bg-gray-200 transition-colors duration-150 border-r border-gray-300" data-id="element-639">
                Workshops
              </Link>
              <Link to="/locatie-huren" className="bg-gray-100 text-gray-800 text-center py-4 px-4 font-medium uppercase tracking-wide hover:bg-gray-200 transition-colors duration-150 border-r border-gray-300" data-id="element-640">
                Zaalverhuur
              </Link>
              <Link to="/koffiebar" className="bg-gray-100 text-gray-800 text-center py-4 px-4 font-medium uppercase tracking-wide hover:bg-gray-200 transition-colors duration-150" data-id="element-641">
                Eten & drinken
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Featured workshops section */}
      <section className="py-16 bg-gray-50" data-id="element-642">
        <div className="container mx-auto px-4" data-id="element-643">
          <div className="flex justify-between items-center mb-8" data-id="element-644">
            <h2 className="text-2xl md:text-3xl font-bold" data-id="element-645">
              Uitgelichte Workshops
            </h2>
            <Link to="/workshops" className="text-gray-600 hover:underline flex items-center group" data-id="element-646">
              Bekijk de kalender{' '}
              <ArrowRight size={16} className="ml-1 group-hover:translate-x-1 transition-transform duration-200" data-id="element-647" />
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-648">
            {featuredWorkshops.map(workshop => <WorkshopCard key={workshop.id} {...workshop} data-id="element-649" />)}
          </div>
        </div>
      </section>

      {/* Stories slider */}
      <QuoteSlider stories={stories.filter(s => s.category === 'general')} data-id="element-650" />

      {/* Maekerscafés section */}
      <section className="py-16" data-id="element-651">
        <div className="container mx-auto px-4" data-id="element-652">
          <h2 className="text-2xl md:text-3xl font-bold mb-8" data-id="element-653">
            Onze Maekerscafés
          </h2>

          {/* Intro with image */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center mb-12" data-id="element-654">
            <div data-id="element-655">
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-656">
                Maekerscafés zijn laagdrempelige, gezellige bijeenkomsten rond
                een creatief thema. Je hoeft geen expert te zijn — breng gewoon
                je nieuwsgierigheid mee. Elke editie staat in het teken van een
                ander ambacht, techniek of gewoon samen plezier maken.
              </p>
            </div>
            <div className="border-2 border-dashed border-gray-300 h-64 flex items-center justify-center bg-gray-100 rounded-lg" data-id="element-657">
              <span className="text-gray-400" data-id="element-658">Maekerscafé sfeerbeeld</span>
            </div>
          </div>

          {/* Themes grid */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-10" data-id="element-659">
            {[{
            name: 'Spelletjesavond',
            icon: <Dice5 size={24} data-id="element-660" />
          }, {
            name: 'Creative Meet Up',
            icon: <Sparkles size={24} data-id="element-661" />
          }, {
            name: 'Pen(seel) en Papier',
            icon: <PenTool size={24} data-id="element-662" />
          }, {
            name: 'Druk Druk Druk',
            icon: <Printer size={24} data-id="element-663" />
          }, {
            name: 'Draad',
            icon: <Cable size={24} data-id="element-664" />
          }, {
            name: 'Draadgeluk',
            icon: <Heart size={24} data-id="element-665" />
          }, {
            name: 'Juwelen',
            icon: <Gem size={24} data-id="element-666" />
          }, {
            name: 'Vrij Maekerscafé',
            icon: <Palette size={24} data-id="element-667" />
          }].map(theme => <div key={theme.name} className="flex flex-col items-center text-center border border-gray-200 rounded-lg p-4 bg-white" data-id="element-668">
                <div className="mb-3 p-3 bg-gray-100 rounded-full text-gray-600" data-id="element-669">
                  {theme.icon}
                </div>
                <span className="text-sm font-medium" data-id="element-670">{theme.name}</span>
              </div>)}
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-671">
            <Link to="/maekerscafés" data-id="element-672">
              <Button variant="primary" size="medium" rightIcon={<ArrowRight size={18} data-id="element-674" />} data-id="element-673">
                Alles over Maekerscafés
              </Button>
            </Link>
            <Link to="/maekerscafés#agenda" data-id="element-675">
              <Button variant="secondary" size="medium" rightIcon={<ArrowRight size={18} data-id="element-677" />} data-id="element-676">
                Komende Maekerscafés
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Locatie huren section */}
      <section className="py-16 bg-gray-100" data-id="element-678">
        <div className="container mx-auto px-4" data-id="element-679">
          <div className="max-w-2xl mx-auto text-center" data-id="element-680">
            <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-681">Zaal huren?</h2>
            <p className="text-gray-600 mb-8" data-id="element-682">
              De Maekerij beschikt over een (vergader)zaal waar je op een
              rustige manier kan samenkomen.
            </p>
            <Link to="/locatie-huren" data-id="element-683">
              <Button variant="primary" size="medium" data-id="element-684">
                Meer informatie
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Koffiebar section */}
      <section className="py-16" data-id="element-685">
        <div className="container mx-auto px-4" data-id="element-686">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center max-w-5xl mx-auto" data-id="element-687">
            <div className="border-2 border-dashed border-gray-300 h-64 flex items-center justify-center bg-gray-100 rounded-lg" data-id="element-688">
              <span className="text-gray-400" data-id="element-689">Koffiebar sfeerbeeld</span>
            </div>
            <div data-id="element-690">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-691">
                Onze Koffiebar
              </h2>
              <p className="text-gray-600 leading-relaxed mb-4" data-id="element-692">
                De koffiebar is het kloppende hart van De Maekerij. Geniet van
                specialty koffie, huisgemaakt gebak en verse broodjes in een
                gezellige, creatieve sfeer. Of je nu even pauzeert tussen
                workshops of gewoon langskomt voor een kop koffie — je bent
                altijd welkom.
              </p>
              <div className="flex flex-col sm:flex-row gap-3" data-id="element-693">
                <Link to="/koffiebar" data-id="element-694">
                  <Button variant="primary" size="medium" rightIcon={<ArrowRight size={18} data-id="element-696" />} data-id="element-695">
                    Meer over de koffiebar
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}